import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../../../shared/selectors/analytics';
import { trackPreviewBlockClick } from './tracking';
import template from './short-form-object-preview.jade';

export default angular
  .module('cian.addForm.aboutBuildingShortFormObjectPreview', [])
  .directive('cianAfAboutBuildingShortFormObjectPreview', [
    function () {
      return {
        scope: {},
        controller: [
          'addFormService',
          'simpleFormService',
          '$scope',
          'store',
          function (addFormService, simpleFormService, $scope, store) {
            this.ad = addFormService.ad;
            this.heading = this.ad.geo.userInput;
            this.year = this.ad.building.buildYear;
            this.floors = this.ad.building.floorsCount;
            this.passengerLifts = this.ad.building.passengerLiftsCount || 'нет';
            this.cargoLifts = this.ad.building.cargoLiftsCount || 'нет';

            $scope.handlePreviewBlockClick = ($event, target) => {
              $event.preventDefault();
              $event.stopPropagation();

              const state = store.getState();
              const analyticsOfferStatus = selectAnalyticsOfferStatus(state);
              const analyticsProduct = selectAnalyticsProduct(state);

              simpleFormService.showAboutBuildingFields();

              trackPreviewBlockClick({ analyticsOfferStatus, analyticsProduct, target });
            };
          },
        ],
        controllerAs: 'c',
        template,
      };
    },
  ]).name;
